/**
 * Generated by orval v8.9.0 🍺
 * Do not edit manually.
 * CGuard.Api | v1
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery, useSuspenseQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';

import type {
  DesignateNetworkIntegrationRequest,
  GetV1SitesParams,
  GetV1SitesSearchGeoParams,
  HttpValidationProblemDetails,
  IssueSiteComplianceCertificateRequest,
  MarkSiteLiveRequest,
  NetworkIntegrationDesignationResponse,
  OverrideSiteGoLiveRequest,
  PagedResultOfSiteResponse,
  ProblemDetails,
  ProvisionSiteRequest,
  RestoreSiteRequest,
  SiteComplianceCertificateResponse,
  SiteComplianceStatusResponse,
  SiteOperatorProfile,
  SiteResponse,
  TransitionSiteComplianceCertificateRequest,
  UpdateAudioClassesRequest,
  UpdateSiteRequest,
} from '../../models';

import { cguardFetcher } from '../../../runtime/fetcher';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export type sitesOperatorProfileResponse200 = {
  data: SiteOperatorProfile;
  status: 200;
};

export type sitesOperatorProfileResponse400 = {
  data: HttpValidationProblemDetails;
  status: 400;
};

export type sitesOperatorProfileResponse404 = {
  data: ProblemDetails;
  status: 404;
};

export type sitesOperatorProfileResponse409 = {
  data: ProblemDetails;
  status: 409;
};

export type sitesOperatorProfileResponseSuccess = sitesOperatorProfileResponse200 & {
  headers: Headers;
};
export type sitesOperatorProfileResponseError = (
  | sitesOperatorProfileResponse400
  | sitesOperatorProfileResponse404
  | sitesOperatorProfileResponse409
) & {
  headers: Headers;
};

export type sitesOperatorProfileResponse =
  | sitesOperatorProfileResponseSuccess
  | sitesOperatorProfileResponseError;

export const getSitesOperatorProfileUrl = (siteId: string) => {
  return `/v1/sites/${siteId}/operator-profile`;
};

export const sitesOperatorProfile = async (
  siteId: string,
  options?: RequestInit,
): Promise<sitesOperatorProfileResponse> => {
  return cguardFetcher<sitesOperatorProfileResponse>(getSitesOperatorProfileUrl(siteId), {
    ...options,
    method: 'GET',
  });
};

export const getSitesOperatorProfileQueryKey = (siteId: string) => {
  return [`/v1/sites/${siteId}/operator-profile`] as const;
};

export const getSitesOperatorProfileQueryOptions = <
  TData = Awaited<ReturnType<typeof sitesOperatorProfile>>,
  TError = HttpValidationProblemDetails | ProblemDetails,
>(
  siteId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sitesOperatorProfile>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSitesOperatorProfileQueryKey(siteId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof sitesOperatorProfile>>> = ({ signal }) =>
    sitesOperatorProfile(siteId, { signal, ...requestOptions });

  return { queryKey, queryFn, enabled: !!siteId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof sitesOperatorProfile>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type SitesOperatorProfileQueryResult = NonNullable<
  Awaited<ReturnType<typeof sitesOperatorProfile>>
>;
export type SitesOperatorProfileQueryError = HttpValidationProblemDetails | ProblemDetails;

export function useSitesOperatorProfile<
  TData = Awaited<ReturnType<typeof sitesOperatorProfile>>,
  TError = HttpValidationProblemDetails | ProblemDetails,
>(
  siteId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sitesOperatorProfile>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesOperatorProfile>>,
          TError,
          Awaited<ReturnType<typeof sitesOperatorProfile>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSitesOperatorProfile<
  TData = Awaited<ReturnType<typeof sitesOperatorProfile>>,
  TError = HttpValidationProblemDetails | ProblemDetails,
>(
  siteId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sitesOperatorProfile>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesOperatorProfile>>,
          TError,
          Awaited<ReturnType<typeof sitesOperatorProfile>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSitesOperatorProfile<
  TData = Awaited<ReturnType<typeof sitesOperatorProfile>>,
  TError = HttpValidationProblemDetails | ProblemDetails,
>(
  siteId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sitesOperatorProfile>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useSitesOperatorProfile<
  TData = Awaited<ReturnType<typeof sitesOperatorProfile>>,
  TError = HttpValidationProblemDetails | ProblemDetails,
>(
  siteId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sitesOperatorProfile>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getSitesOperatorProfileQueryOptions(siteId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getSitesOperatorProfileSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof sitesOperatorProfile>>,
  TError = HttpValidationProblemDetails | ProblemDetails,
>(
  siteId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof sitesOperatorProfile>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSitesOperatorProfileQueryKey(siteId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof sitesOperatorProfile>>> = ({ signal }) =>
    sitesOperatorProfile(siteId, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof sitesOperatorProfile>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type SitesOperatorProfileSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof sitesOperatorProfile>>
>;
export type SitesOperatorProfileSuspenseQueryError = HttpValidationProblemDetails | ProblemDetails;

export function useSitesOperatorProfileSuspense<
  TData = Awaited<ReturnType<typeof sitesOperatorProfile>>,
  TError = HttpValidationProblemDetails | ProblemDetails,
>(
  siteId: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof sitesOperatorProfile>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSitesOperatorProfileSuspense<
  TData = Awaited<ReturnType<typeof sitesOperatorProfile>>,
  TError = HttpValidationProblemDetails | ProblemDetails,
>(
  siteId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof sitesOperatorProfile>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSitesOperatorProfileSuspense<
  TData = Awaited<ReturnType<typeof sitesOperatorProfile>>,
  TError = HttpValidationProblemDetails | ProblemDetails,
>(
  siteId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof sitesOperatorProfile>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useSitesOperatorProfileSuspense<
  TData = Awaited<ReturnType<typeof sitesOperatorProfile>>,
  TError = HttpValidationProblemDetails | ProblemDetails,
>(
  siteId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof sitesOperatorProfile>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getSitesOperatorProfileSuspenseQueryOptions(siteId, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export type sitesUpdateOperatorProfileResponse204 = {
  data: void;
  status: 204;
};

export type sitesUpdateOperatorProfileResponse400 = {
  data: HttpValidationProblemDetails;
  status: 400;
};

export type sitesUpdateOperatorProfileResponse404 = {
  data: ProblemDetails;
  status: 404;
};

export type sitesUpdateOperatorProfileResponse409 = {
  data: ProblemDetails;
  status: 409;
};

export type sitesUpdateOperatorProfileResponseSuccess = sitesUpdateOperatorProfileResponse204 & {
  headers: Headers;
};
export type sitesUpdateOperatorProfileResponseError = (
  | sitesUpdateOperatorProfileResponse400
  | sitesUpdateOperatorProfileResponse404
  | sitesUpdateOperatorProfileResponse409
) & {
  headers: Headers;
};

export type sitesUpdateOperatorProfileResponse =
  | sitesUpdateOperatorProfileResponseSuccess
  | sitesUpdateOperatorProfileResponseError;

export const getSitesUpdateOperatorProfileUrl = (siteId: string) => {
  return `/v1/sites/${siteId}/operator-profile`;
};

export const sitesUpdateOperatorProfile = async (
  siteId: string,
  siteOperatorProfile: SiteOperatorProfile,
  options?: RequestInit,
): Promise<sitesUpdateOperatorProfileResponse> => {
  return cguardFetcher<sitesUpdateOperatorProfileResponse>(
    getSitesUpdateOperatorProfileUrl(siteId),
    {
      ...options,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(siteOperatorProfile),
    },
  );
};

export const getSitesUpdateOperatorProfileMutationOptions = <
  TError = HttpValidationProblemDetails | ProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sitesUpdateOperatorProfile>>,
    TError,
    { siteId: string; data: SiteOperatorProfile },
    TContext
  >;
  request?: SecondParameter<typeof cguardFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sitesUpdateOperatorProfile>>,
  TError,
  { siteId: string; data: SiteOperatorProfile },
  TContext
> => {
  const mutationKey = ['sitesUpdateOperatorProfile'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sitesUpdateOperatorProfile>>,
    { siteId: string; data: SiteOperatorProfile }
  > = (props) => {
    const { siteId, data } = props ?? {};

    return sitesUpdateOperatorProfile(siteId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SitesUpdateOperatorProfileMutationResult = NonNullable<
  Awaited<ReturnType<typeof sitesUpdateOperatorProfile>>
>;
export type SitesUpdateOperatorProfileMutationBody = SiteOperatorProfile;
export type SitesUpdateOperatorProfileMutationError = HttpValidationProblemDetails | ProblemDetails;

export const useSitesUpdateOperatorProfile = <
  TError = HttpValidationProblemDetails | ProblemDetails,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof sitesUpdateOperatorProfile>>,
      TError,
      { siteId: string; data: SiteOperatorProfile },
      TContext
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof sitesUpdateOperatorProfile>>,
  TError,
  { siteId: string; data: SiteOperatorProfile },
  TContext
> => {
  return useMutation(getSitesUpdateOperatorProfileMutationOptions(options), queryClient);
};
export type postV1SitesResponse201 = {
  data: SiteResponse;
  status: 201;
};

export type postV1SitesResponse400 = {
  data: HttpValidationProblemDetails;
  status: 400;
};

export type postV1SitesResponse404 = {
  data: ProblemDetails;
  status: 404;
};

export type postV1SitesResponse409 = {
  data: ProblemDetails;
  status: 409;
};

export type postV1SitesResponseSuccess = postV1SitesResponse201 & {
  headers: Headers;
};
export type postV1SitesResponseError = (
  | postV1SitesResponse400
  | postV1SitesResponse404
  | postV1SitesResponse409
) & {
  headers: Headers;
};

export type postV1SitesResponse = postV1SitesResponseSuccess | postV1SitesResponseError;

export const getPostV1SitesUrl = () => {
  return `/v1/sites`;
};

export const postV1Sites = async (
  provisionSiteRequest: ProvisionSiteRequest,
  options?: RequestInit,
): Promise<postV1SitesResponse> => {
  return cguardFetcher<postV1SitesResponse>(getPostV1SitesUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(provisionSiteRequest),
  });
};

export const getPostV1SitesMutationOptions = <
  TError = HttpValidationProblemDetails | ProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV1Sites>>,
    TError,
    { data: ProvisionSiteRequest },
    TContext
  >;
  request?: SecondParameter<typeof cguardFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV1Sites>>,
  TError,
  { data: ProvisionSiteRequest },
  TContext
> => {
  const mutationKey = ['postV1Sites'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV1Sites>>,
    { data: ProvisionSiteRequest }
  > = (props) => {
    const { data } = props ?? {};

    return postV1Sites(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV1SitesMutationResult = NonNullable<Awaited<ReturnType<typeof postV1Sites>>>;
export type PostV1SitesMutationBody = ProvisionSiteRequest;
export type PostV1SitesMutationError = HttpValidationProblemDetails | ProblemDetails;

export const usePostV1Sites = <
  TError = HttpValidationProblemDetails | ProblemDetails,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV1Sites>>,
      TError,
      { data: ProvisionSiteRequest },
      TContext
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postV1Sites>>,
  TError,
  { data: ProvisionSiteRequest },
  TContext
> => {
  return useMutation(getPostV1SitesMutationOptions(options), queryClient);
};
export type getV1SitesResponse200 = {
  data: PagedResultOfSiteResponse;
  status: 200;
};

export type getV1SitesResponse400 = {
  data: HttpValidationProblemDetails;
  status: 400;
};

export type getV1SitesResponse404 = {
  data: ProblemDetails;
  status: 404;
};

export type getV1SitesResponse409 = {
  data: ProblemDetails;
  status: 409;
};

export type getV1SitesResponseSuccess = getV1SitesResponse200 & {
  headers: Headers;
};
export type getV1SitesResponseError = (
  | getV1SitesResponse400
  | getV1SitesResponse404
  | getV1SitesResponse409
) & {
  headers: Headers;
};

export type getV1SitesResponse = getV1SitesResponseSuccess | getV1SitesResponseError;

export const getGetV1SitesUrl = (params?: GetV1SitesParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/sites?${stringifiedParams}` : `/v1/sites`;
};

export const getV1Sites = async (
  params?: GetV1SitesParams,
  options?: RequestInit,
): Promise<getV1SitesResponse> => {
  return cguardFetcher<getV1SitesResponse>(getGetV1SitesUrl(params), {
    ...options,
    method: 'GET',
  });
};

export const getGetV1SitesQueryKey = (params?: GetV1SitesParams) => {
  return [`/v1/sites`, ...(params ? [params] : [])] as const;
};

export const getGetV1SitesQueryOptions = <
  TData = Awaited<ReturnType<typeof getV1Sites>>,
  TError = HttpValidationProblemDetails | ProblemDetails,
>(
  params?: GetV1SitesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV1Sites>>, TError, TData>>;
    request?: SecondParameter<typeof cguardFetcher>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetV1SitesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV1Sites>>> = ({ signal }) =>
    getV1Sites(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV1Sites>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV1SitesQueryResult = NonNullable<Awaited<ReturnType<typeof getV1Sites>>>;
export type GetV1SitesQueryError = HttpValidationProblemDetails | ProblemDetails;

export function useGetV1Sites<
  TData = Awaited<ReturnType<typeof getV1Sites>>,
  TError = HttpValidationProblemDetails | ProblemDetails,
>(
  params: undefined | GetV1SitesParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV1Sites>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1Sites>>,
          TError,
          Awaited<ReturnType<typeof getV1Sites>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetV1Sites<
  TData = Awaited<ReturnType<typeof getV1Sites>>,
  TError = HttpValidationProblemDetails | ProblemDetails,
>(
  params?: GetV1SitesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV1Sites>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1Sites>>,
          TError,
          Awaited<ReturnType<typeof getV1Sites>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetV1Sites<
  TData = Awaited<ReturnType<typeof getV1Sites>>,
  TError = HttpValidationProblemDetails | ProblemDetails,
>(
  params?: GetV1SitesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV1Sites>>, TError, TData>>;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetV1Sites<
  TData = Awaited<ReturnType<typeof getV1Sites>>,
  TError = HttpValidationProblemDetails | ProblemDetails,
>(
  params?: GetV1SitesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV1Sites>>, TError, TData>>;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV1SitesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getGetV1SitesSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getV1Sites>>,
  TError = HttpValidationProblemDetails | ProblemDetails,
>(
  params?: GetV1SitesParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getV1Sites>>, TError, TData>>;
    request?: SecondParameter<typeof cguardFetcher>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetV1SitesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV1Sites>>> = ({ signal }) =>
    getV1Sites(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getV1Sites>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV1SitesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getV1Sites>>>;
export type GetV1SitesSuspenseQueryError = HttpValidationProblemDetails | ProblemDetails;

export function useGetV1SitesSuspense<
  TData = Awaited<ReturnType<typeof getV1Sites>>,
  TError = HttpValidationProblemDetails | ProblemDetails,
>(
  params: undefined | GetV1SitesParams,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getV1Sites>>, TError, TData>>;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetV1SitesSuspense<
  TData = Awaited<ReturnType<typeof getV1Sites>>,
  TError = HttpValidationProblemDetails | ProblemDetails,
>(
  params?: GetV1SitesParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getV1Sites>>, TError, TData>>;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetV1SitesSuspense<
  TData = Awaited<ReturnType<typeof getV1Sites>>,
  TError = HttpValidationProblemDetails | ProblemDetails,
>(
  params?: GetV1SitesParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getV1Sites>>, TError, TData>>;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetV1SitesSuspense<
  TData = Awaited<ReturnType<typeof getV1Sites>>,
  TError = HttpValidationProblemDetails | ProblemDetails,
>(
  params?: GetV1SitesParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getV1Sites>>, TError, TData>>;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV1SitesSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export type getV1SitesIdResponse200 = {
  data: SiteResponse;
  status: 200;
};

export type getV1SitesIdResponse400 = {
  data: HttpValidationProblemDetails;
  status: 400;
};

export type getV1SitesIdResponse404 = {
  data: ProblemDetails;
  status: 404;
};

export type getV1SitesIdResponse409 = {
  data: ProblemDetails;
  status: 409;
};

export type getV1SitesIdResponseSuccess = getV1SitesIdResponse200 & {
  headers: Headers;
};
export type getV1SitesIdResponseError = (
  | getV1SitesIdResponse400
  | getV1SitesIdResponse404
  | getV1SitesIdResponse409
) & {
  headers: Headers;
};

export type getV1SitesIdResponse = getV1SitesIdResponseSuccess | getV1SitesIdResponseError;

export const getGetV1SitesIdUrl = (id: string) => {
  return `/v1/sites/${id}`;
};

export const getV1SitesId = async (
  id: string,
  options?: RequestInit,
): Promise<getV1SitesIdResponse> => {
  return cguardFetcher<getV1SitesIdResponse>(getGetV1SitesIdUrl(id), {
    ...options,
    method: 'GET',
  });
};

export const getGetV1SitesIdQueryKey = (id: string) => {
  return [`/v1/sites/${id}`] as const;
};

export const getGetV1SitesIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV1SitesId>>,
  TError = HttpValidationProblemDetails | ProblemDetails,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV1SitesId>>, TError, TData>>;
    request?: SecondParameter<typeof cguardFetcher>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetV1SitesIdQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV1SitesId>>> = ({ signal }) =>
    getV1SitesId(id, { signal, ...requestOptions });

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV1SitesId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV1SitesIdQueryResult = NonNullable<Awaited<ReturnType<typeof getV1SitesId>>>;
export type GetV1SitesIdQueryError = HttpValidationProblemDetails | ProblemDetails;

export function useGetV1SitesId<
  TData = Awaited<ReturnType<typeof getV1SitesId>>,
  TError = HttpValidationProblemDetails | ProblemDetails,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV1SitesId>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1SitesId>>,
          TError,
          Awaited<ReturnType<typeof getV1SitesId>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetV1SitesId<
  TData = Awaited<ReturnType<typeof getV1SitesId>>,
  TError = HttpValidationProblemDetails | ProblemDetails,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV1SitesId>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1SitesId>>,
          TError,
          Awaited<ReturnType<typeof getV1SitesId>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetV1SitesId<
  TData = Awaited<ReturnType<typeof getV1SitesId>>,
  TError = HttpValidationProblemDetails | ProblemDetails,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV1SitesId>>, TError, TData>>;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetV1SitesId<
  TData = Awaited<ReturnType<typeof getV1SitesId>>,
  TError = HttpValidationProblemDetails | ProblemDetails,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV1SitesId>>, TError, TData>>;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV1SitesIdQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getGetV1SitesIdSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getV1SitesId>>,
  TError = HttpValidationProblemDetails | ProblemDetails,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getV1SitesId>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetV1SitesIdQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV1SitesId>>> = ({ signal }) =>
    getV1SitesId(id, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getV1SitesId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV1SitesIdSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getV1SitesId>>>;
export type GetV1SitesIdSuspenseQueryError = HttpValidationProblemDetails | ProblemDetails;

export function useGetV1SitesIdSuspense<
  TData = Awaited<ReturnType<typeof getV1SitesId>>,
  TError = HttpValidationProblemDetails | ProblemDetails,
>(
  id: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getV1SitesId>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetV1SitesIdSuspense<
  TData = Awaited<ReturnType<typeof getV1SitesId>>,
  TError = HttpValidationProblemDetails | ProblemDetails,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getV1SitesId>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetV1SitesIdSuspense<
  TData = Awaited<ReturnType<typeof getV1SitesId>>,
  TError = HttpValidationProblemDetails | ProblemDetails,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getV1SitesId>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetV1SitesIdSuspense<
  TData = Awaited<ReturnType<typeof getV1SitesId>>,
  TError = HttpValidationProblemDetails | ProblemDetails,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getV1SitesId>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV1SitesIdSuspenseQueryOptions(id, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export type patchV1SitesIdResponse204 = {
  data: void;
  status: 204;
};

export type patchV1SitesIdResponse400 = {
  data: HttpValidationProblemDetails;
  status: 400;
};

export type patchV1SitesIdResponse404 = {
  data: ProblemDetails;
  status: 404;
};

export type patchV1SitesIdResponse409 = {
  data: ProblemDetails;
  status: 409;
};

export type patchV1SitesIdResponseSuccess = patchV1SitesIdResponse204 & {
  headers: Headers;
};
export type patchV1SitesIdResponseError = (
  | patchV1SitesIdResponse400
  | patchV1SitesIdResponse404
  | patchV1SitesIdResponse409
) & {
  headers: Headers;
};

export type patchV1SitesIdResponse = patchV1SitesIdResponseSuccess | patchV1SitesIdResponseError;

export const getPatchV1SitesIdUrl = (id: string) => {
  return `/v1/sites/${id}`;
};

export const patchV1SitesId = async (
  id: string,
  updateSiteRequest: UpdateSiteRequest,
  options?: RequestInit,
): Promise<patchV1SitesIdResponse> => {
  return cguardFetcher<patchV1SitesIdResponse>(getPatchV1SitesIdUrl(id), {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateSiteRequest),
  });
};

export const getPatchV1SitesIdMutationOptions = <
  TError = HttpValidationProblemDetails | ProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchV1SitesId>>,
    TError,
    { id: string; data: UpdateSiteRequest },
    TContext
  >;
  request?: SecondParameter<typeof cguardFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchV1SitesId>>,
  TError,
  { id: string; data: UpdateSiteRequest },
  TContext
> => {
  const mutationKey = ['patchV1SitesId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchV1SitesId>>,
    { id: string; data: UpdateSiteRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return patchV1SitesId(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchV1SitesIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchV1SitesId>>>;
export type PatchV1SitesIdMutationBody = UpdateSiteRequest;
export type PatchV1SitesIdMutationError = HttpValidationProblemDetails | ProblemDetails;

export const usePatchV1SitesId = <
  TError = HttpValidationProblemDetails | ProblemDetails,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchV1SitesId>>,
      TError,
      { id: string; data: UpdateSiteRequest },
      TContext
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof patchV1SitesId>>,
  TError,
  { id: string; data: UpdateSiteRequest },
  TContext
> => {
  return useMutation(getPatchV1SitesIdMutationOptions(options), queryClient);
};
export type getV1SitesIdReadinessResponse200 = {
  data: SiteComplianceStatusResponse;
  status: 200;
};

export type getV1SitesIdReadinessResponse400 = {
  data: HttpValidationProblemDetails;
  status: 400;
};

export type getV1SitesIdReadinessResponse404 = {
  data: ProblemDetails;
  status: 404;
};

export type getV1SitesIdReadinessResponse409 = {
  data: ProblemDetails;
  status: 409;
};

export type getV1SitesIdReadinessResponseSuccess = getV1SitesIdReadinessResponse200 & {
  headers: Headers;
};
export type getV1SitesIdReadinessResponseError = (
  | getV1SitesIdReadinessResponse400
  | getV1SitesIdReadinessResponse404
  | getV1SitesIdReadinessResponse409
) & {
  headers: Headers;
};

export type getV1SitesIdReadinessResponse =
  | getV1SitesIdReadinessResponseSuccess
  | getV1SitesIdReadinessResponseError;

export const getGetV1SitesIdReadinessUrl = (id: string) => {
  return `/v1/sites/${id}/readiness`;
};

export const getV1SitesIdReadiness = async (
  id: string,
  options?: RequestInit,
): Promise<getV1SitesIdReadinessResponse> => {
  return cguardFetcher<getV1SitesIdReadinessResponse>(getGetV1SitesIdReadinessUrl(id), {
    ...options,
    method: 'GET',
  });
};

export const getGetV1SitesIdReadinessQueryKey = (id: string) => {
  return [`/v1/sites/${id}/readiness`] as const;
};

export const getGetV1SitesIdReadinessQueryOptions = <
  TData = Awaited<ReturnType<typeof getV1SitesIdReadiness>>,
  TError = HttpValidationProblemDetails | ProblemDetails,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV1SitesIdReadiness>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetV1SitesIdReadinessQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV1SitesIdReadiness>>> = ({ signal }) =>
    getV1SitesIdReadiness(id, { signal, ...requestOptions });

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV1SitesIdReadiness>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV1SitesIdReadinessQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV1SitesIdReadiness>>
>;
export type GetV1SitesIdReadinessQueryError = HttpValidationProblemDetails | ProblemDetails;

export function useGetV1SitesIdReadiness<
  TData = Awaited<ReturnType<typeof getV1SitesIdReadiness>>,
  TError = HttpValidationProblemDetails | ProblemDetails,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV1SitesIdReadiness>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1SitesIdReadiness>>,
          TError,
          Awaited<ReturnType<typeof getV1SitesIdReadiness>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetV1SitesIdReadiness<
  TData = Awaited<ReturnType<typeof getV1SitesIdReadiness>>,
  TError = HttpValidationProblemDetails | ProblemDetails,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV1SitesIdReadiness>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1SitesIdReadiness>>,
          TError,
          Awaited<ReturnType<typeof getV1SitesIdReadiness>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetV1SitesIdReadiness<
  TData = Awaited<ReturnType<typeof getV1SitesIdReadiness>>,
  TError = HttpValidationProblemDetails | ProblemDetails,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV1SitesIdReadiness>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetV1SitesIdReadiness<
  TData = Awaited<ReturnType<typeof getV1SitesIdReadiness>>,
  TError = HttpValidationProblemDetails | ProblemDetails,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV1SitesIdReadiness>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV1SitesIdReadinessQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getGetV1SitesIdReadinessSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getV1SitesIdReadiness>>,
  TError = HttpValidationProblemDetails | ProblemDetails,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getV1SitesIdReadiness>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetV1SitesIdReadinessQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV1SitesIdReadiness>>> = ({ signal }) =>
    getV1SitesIdReadiness(id, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getV1SitesIdReadiness>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV1SitesIdReadinessSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV1SitesIdReadiness>>
>;
export type GetV1SitesIdReadinessSuspenseQueryError = HttpValidationProblemDetails | ProblemDetails;

export function useGetV1SitesIdReadinessSuspense<
  TData = Awaited<ReturnType<typeof getV1SitesIdReadiness>>,
  TError = HttpValidationProblemDetails | ProblemDetails,
>(
  id: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getV1SitesIdReadiness>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetV1SitesIdReadinessSuspense<
  TData = Awaited<ReturnType<typeof getV1SitesIdReadiness>>,
  TError = HttpValidationProblemDetails | ProblemDetails,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getV1SitesIdReadiness>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetV1SitesIdReadinessSuspense<
  TData = Awaited<ReturnType<typeof getV1SitesIdReadiness>>,
  TError = HttpValidationProblemDetails | ProblemDetails,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getV1SitesIdReadiness>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetV1SitesIdReadinessSuspense<
  TData = Awaited<ReturnType<typeof getV1SitesIdReadiness>>,
  TError = HttpValidationProblemDetails | ProblemDetails,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getV1SitesIdReadiness>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV1SitesIdReadinessSuspenseQueryOptions(id, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export type postV1SitesIdReadinessSubmissionsResponse200 = {
  data: SiteComplianceStatusResponse;
  status: 200;
};

export type postV1SitesIdReadinessSubmissionsResponse400 = {
  data: HttpValidationProblemDetails;
  status: 400;
};

export type postV1SitesIdReadinessSubmissionsResponse404 = {
  data: ProblemDetails;
  status: 404;
};

export type postV1SitesIdReadinessSubmissionsResponse409 = {
  data: ProblemDetails;
  status: 409;
};

export type postV1SitesIdReadinessSubmissionsResponseSuccess =
  postV1SitesIdReadinessSubmissionsResponse200 & {
    headers: Headers;
  };
export type postV1SitesIdReadinessSubmissionsResponseError = (
  | postV1SitesIdReadinessSubmissionsResponse400
  | postV1SitesIdReadinessSubmissionsResponse404
  | postV1SitesIdReadinessSubmissionsResponse409
) & {
  headers: Headers;
};

export type postV1SitesIdReadinessSubmissionsResponse =
  | postV1SitesIdReadinessSubmissionsResponseSuccess
  | postV1SitesIdReadinessSubmissionsResponseError;

export const getPostV1SitesIdReadinessSubmissionsUrl = (id: string) => {
  return `/v1/sites/${id}/readiness/submissions`;
};

export const postV1SitesIdReadinessSubmissions = async (
  id: string,
  options?: RequestInit,
): Promise<postV1SitesIdReadinessSubmissionsResponse> => {
  return cguardFetcher<postV1SitesIdReadinessSubmissionsResponse>(
    getPostV1SitesIdReadinessSubmissionsUrl(id),
    {
      ...options,
      method: 'POST',
    },
  );
};

export const getPostV1SitesIdReadinessSubmissionsMutationOptions = <
  TError = HttpValidationProblemDetails | ProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV1SitesIdReadinessSubmissions>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof cguardFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV1SitesIdReadinessSubmissions>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['postV1SitesIdReadinessSubmissions'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV1SitesIdReadinessSubmissions>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return postV1SitesIdReadinessSubmissions(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV1SitesIdReadinessSubmissionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV1SitesIdReadinessSubmissions>>
>;

export type PostV1SitesIdReadinessSubmissionsMutationError =
  | HttpValidationProblemDetails
  | ProblemDetails;

export const usePostV1SitesIdReadinessSubmissions = <
  TError = HttpValidationProblemDetails | ProblemDetails,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV1SitesIdReadinessSubmissions>>,
      TError,
      { id: string },
      TContext
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postV1SitesIdReadinessSubmissions>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getPostV1SitesIdReadinessSubmissionsMutationOptions(options), queryClient);
};
export type postV1SitesIdComplianceCertificatesResponse200 = {
  data: SiteComplianceCertificateResponse;
  status: 200;
};

export type postV1SitesIdComplianceCertificatesResponse400 = {
  data: HttpValidationProblemDetails;
  status: 400;
};

export type postV1SitesIdComplianceCertificatesResponse404 = {
  data: ProblemDetails;
  status: 404;
};

export type postV1SitesIdComplianceCertificatesResponse409 = {
  data: ProblemDetails;
  status: 409;
};

export type postV1SitesIdComplianceCertificatesResponseSuccess =
  postV1SitesIdComplianceCertificatesResponse200 & {
    headers: Headers;
  };
export type postV1SitesIdComplianceCertificatesResponseError = (
  | postV1SitesIdComplianceCertificatesResponse400
  | postV1SitesIdComplianceCertificatesResponse404
  | postV1SitesIdComplianceCertificatesResponse409
) & {
  headers: Headers;
};

export type postV1SitesIdComplianceCertificatesResponse =
  | postV1SitesIdComplianceCertificatesResponseSuccess
  | postV1SitesIdComplianceCertificatesResponseError;

export const getPostV1SitesIdComplianceCertificatesUrl = (id: string) => {
  return `/v1/sites/${id}/compliance-certificates`;
};

export const postV1SitesIdComplianceCertificates = async (
  id: string,
  issueSiteComplianceCertificateRequest: IssueSiteComplianceCertificateRequest,
  options?: RequestInit,
): Promise<postV1SitesIdComplianceCertificatesResponse> => {
  return cguardFetcher<postV1SitesIdComplianceCertificatesResponse>(
    getPostV1SitesIdComplianceCertificatesUrl(id),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(issueSiteComplianceCertificateRequest),
    },
  );
};

export const getPostV1SitesIdComplianceCertificatesMutationOptions = <
  TError = HttpValidationProblemDetails | ProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV1SitesIdComplianceCertificates>>,
    TError,
    { id: string; data: IssueSiteComplianceCertificateRequest },
    TContext
  >;
  request?: SecondParameter<typeof cguardFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV1SitesIdComplianceCertificates>>,
  TError,
  { id: string; data: IssueSiteComplianceCertificateRequest },
  TContext
> => {
  const mutationKey = ['postV1SitesIdComplianceCertificates'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV1SitesIdComplianceCertificates>>,
    { id: string; data: IssueSiteComplianceCertificateRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return postV1SitesIdComplianceCertificates(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV1SitesIdComplianceCertificatesMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV1SitesIdComplianceCertificates>>
>;
export type PostV1SitesIdComplianceCertificatesMutationBody = IssueSiteComplianceCertificateRequest;
export type PostV1SitesIdComplianceCertificatesMutationError =
  | HttpValidationProblemDetails
  | ProblemDetails;

export const usePostV1SitesIdComplianceCertificates = <
  TError = HttpValidationProblemDetails | ProblemDetails,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV1SitesIdComplianceCertificates>>,
      TError,
      { id: string; data: IssueSiteComplianceCertificateRequest },
      TContext
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postV1SitesIdComplianceCertificates>>,
  TError,
  { id: string; data: IssueSiteComplianceCertificateRequest },
  TContext
> => {
  return useMutation(getPostV1SitesIdComplianceCertificatesMutationOptions(options), queryClient);
};
export type getV1SitesSearchGeoResponse200 = {
  data: SiteResponse[];
  status: 200;
};

export type getV1SitesSearchGeoResponse400 = {
  data: HttpValidationProblemDetails;
  status: 400;
};

export type getV1SitesSearchGeoResponse404 = {
  data: ProblemDetails;
  status: 404;
};

export type getV1SitesSearchGeoResponse409 = {
  data: ProblemDetails;
  status: 409;
};

export type getV1SitesSearchGeoResponseSuccess = getV1SitesSearchGeoResponse200 & {
  headers: Headers;
};
export type getV1SitesSearchGeoResponseError = (
  | getV1SitesSearchGeoResponse400
  | getV1SitesSearchGeoResponse404
  | getV1SitesSearchGeoResponse409
) & {
  headers: Headers;
};

export type getV1SitesSearchGeoResponse =
  | getV1SitesSearchGeoResponseSuccess
  | getV1SitesSearchGeoResponseError;

export const getGetV1SitesSearchGeoUrl = (params: GetV1SitesSearchGeoParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/v1/sites/search/geo?${stringifiedParams}`
    : `/v1/sites/search/geo`;
};

export const getV1SitesSearchGeo = async (
  params: GetV1SitesSearchGeoParams,
  options?: RequestInit,
): Promise<getV1SitesSearchGeoResponse> => {
  return cguardFetcher<getV1SitesSearchGeoResponse>(getGetV1SitesSearchGeoUrl(params), {
    ...options,
    method: 'GET',
  });
};

export const getGetV1SitesSearchGeoQueryKey = (params?: GetV1SitesSearchGeoParams) => {
  return [`/v1/sites/search/geo`, ...(params ? [params] : [])] as const;
};

export const getGetV1SitesSearchGeoQueryOptions = <
  TData = Awaited<ReturnType<typeof getV1SitesSearchGeo>>,
  TError = HttpValidationProblemDetails | ProblemDetails,
>(
  params: GetV1SitesSearchGeoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV1SitesSearchGeo>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetV1SitesSearchGeoQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV1SitesSearchGeo>>> = ({ signal }) =>
    getV1SitesSearchGeo(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV1SitesSearchGeo>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV1SitesSearchGeoQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV1SitesSearchGeo>>
>;
export type GetV1SitesSearchGeoQueryError = HttpValidationProblemDetails | ProblemDetails;

export function useGetV1SitesSearchGeo<
  TData = Awaited<ReturnType<typeof getV1SitesSearchGeo>>,
  TError = HttpValidationProblemDetails | ProblemDetails,
>(
  params: GetV1SitesSearchGeoParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV1SitesSearchGeo>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1SitesSearchGeo>>,
          TError,
          Awaited<ReturnType<typeof getV1SitesSearchGeo>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetV1SitesSearchGeo<
  TData = Awaited<ReturnType<typeof getV1SitesSearchGeo>>,
  TError = HttpValidationProblemDetails | ProblemDetails,
>(
  params: GetV1SitesSearchGeoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV1SitesSearchGeo>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1SitesSearchGeo>>,
          TError,
          Awaited<ReturnType<typeof getV1SitesSearchGeo>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetV1SitesSearchGeo<
  TData = Awaited<ReturnType<typeof getV1SitesSearchGeo>>,
  TError = HttpValidationProblemDetails | ProblemDetails,
>(
  params: GetV1SitesSearchGeoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV1SitesSearchGeo>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetV1SitesSearchGeo<
  TData = Awaited<ReturnType<typeof getV1SitesSearchGeo>>,
  TError = HttpValidationProblemDetails | ProblemDetails,
>(
  params: GetV1SitesSearchGeoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV1SitesSearchGeo>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV1SitesSearchGeoQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getGetV1SitesSearchGeoSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getV1SitesSearchGeo>>,
  TError = HttpValidationProblemDetails | ProblemDetails,
>(
  params: GetV1SitesSearchGeoParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getV1SitesSearchGeo>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetV1SitesSearchGeoQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV1SitesSearchGeo>>> = ({ signal }) =>
    getV1SitesSearchGeo(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getV1SitesSearchGeo>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV1SitesSearchGeoSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV1SitesSearchGeo>>
>;
export type GetV1SitesSearchGeoSuspenseQueryError = HttpValidationProblemDetails | ProblemDetails;

export function useGetV1SitesSearchGeoSuspense<
  TData = Awaited<ReturnType<typeof getV1SitesSearchGeo>>,
  TError = HttpValidationProblemDetails | ProblemDetails,
>(
  params: GetV1SitesSearchGeoParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getV1SitesSearchGeo>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetV1SitesSearchGeoSuspense<
  TData = Awaited<ReturnType<typeof getV1SitesSearchGeo>>,
  TError = HttpValidationProblemDetails | ProblemDetails,
>(
  params: GetV1SitesSearchGeoParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getV1SitesSearchGeo>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetV1SitesSearchGeoSuspense<
  TData = Awaited<ReturnType<typeof getV1SitesSearchGeo>>,
  TError = HttpValidationProblemDetails | ProblemDetails,
>(
  params: GetV1SitesSearchGeoParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getV1SitesSearchGeo>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetV1SitesSearchGeoSuspense<
  TData = Awaited<ReturnType<typeof getV1SitesSearchGeo>>,
  TError = HttpValidationProblemDetails | ProblemDetails,
>(
  params: GetV1SitesSearchGeoParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getV1SitesSearchGeo>>, TError, TData>
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV1SitesSearchGeoSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export type putV1SitesIdNetworkIntegrationModeResponse200 = {
  data: NetworkIntegrationDesignationResponse;
  status: 200;
};

export type putV1SitesIdNetworkIntegrationModeResponse400 = {
  data: HttpValidationProblemDetails;
  status: 400;
};

export type putV1SitesIdNetworkIntegrationModeResponse404 = {
  data: ProblemDetails;
  status: 404;
};

export type putV1SitesIdNetworkIntegrationModeResponse409 = {
  data: ProblemDetails;
  status: 409;
};

export type putV1SitesIdNetworkIntegrationModeResponseSuccess =
  putV1SitesIdNetworkIntegrationModeResponse200 & {
    headers: Headers;
  };
export type putV1SitesIdNetworkIntegrationModeResponseError = (
  | putV1SitesIdNetworkIntegrationModeResponse400
  | putV1SitesIdNetworkIntegrationModeResponse404
  | putV1SitesIdNetworkIntegrationModeResponse409
) & {
  headers: Headers;
};

export type putV1SitesIdNetworkIntegrationModeResponse =
  | putV1SitesIdNetworkIntegrationModeResponseSuccess
  | putV1SitesIdNetworkIntegrationModeResponseError;

export const getPutV1SitesIdNetworkIntegrationModeUrl = (id: string) => {
  return `/v1/sites/${id}/network-integration-mode`;
};

export const putV1SitesIdNetworkIntegrationMode = async (
  id: string,
  designateNetworkIntegrationRequest: DesignateNetworkIntegrationRequest,
  options?: RequestInit,
): Promise<putV1SitesIdNetworkIntegrationModeResponse> => {
  return cguardFetcher<putV1SitesIdNetworkIntegrationModeResponse>(
    getPutV1SitesIdNetworkIntegrationModeUrl(id),
    {
      ...options,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(designateNetworkIntegrationRequest),
    },
  );
};

export const getPutV1SitesIdNetworkIntegrationModeMutationOptions = <
  TError = HttpValidationProblemDetails | ProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putV1SitesIdNetworkIntegrationMode>>,
    TError,
    { id: string; data: DesignateNetworkIntegrationRequest },
    TContext
  >;
  request?: SecondParameter<typeof cguardFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putV1SitesIdNetworkIntegrationMode>>,
  TError,
  { id: string; data: DesignateNetworkIntegrationRequest },
  TContext
> => {
  const mutationKey = ['putV1SitesIdNetworkIntegrationMode'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putV1SitesIdNetworkIntegrationMode>>,
    { id: string; data: DesignateNetworkIntegrationRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return putV1SitesIdNetworkIntegrationMode(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutV1SitesIdNetworkIntegrationModeMutationResult = NonNullable<
  Awaited<ReturnType<typeof putV1SitesIdNetworkIntegrationMode>>
>;
export type PutV1SitesIdNetworkIntegrationModeMutationBody = DesignateNetworkIntegrationRequest;
export type PutV1SitesIdNetworkIntegrationModeMutationError =
  | HttpValidationProblemDetails
  | ProblemDetails;

export const usePutV1SitesIdNetworkIntegrationMode = <
  TError = HttpValidationProblemDetails | ProblemDetails,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putV1SitesIdNetworkIntegrationMode>>,
      TError,
      { id: string; data: DesignateNetworkIntegrationRequest },
      TContext
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putV1SitesIdNetworkIntegrationMode>>,
  TError,
  { id: string; data: DesignateNetworkIntegrationRequest },
  TContext
> => {
  return useMutation(getPutV1SitesIdNetworkIntegrationModeMutationOptions(options), queryClient);
};
export type patchV1SitesIdAudioClassesResponse204 = {
  data: void;
  status: 204;
};

export type patchV1SitesIdAudioClassesResponse400 = {
  data: HttpValidationProblemDetails;
  status: 400;
};

export type patchV1SitesIdAudioClassesResponse404 = {
  data: ProblemDetails;
  status: 404;
};

export type patchV1SitesIdAudioClassesResponse409 = {
  data: ProblemDetails;
  status: 409;
};

export type patchV1SitesIdAudioClassesResponseSuccess = patchV1SitesIdAudioClassesResponse204 & {
  headers: Headers;
};
export type patchV1SitesIdAudioClassesResponseError = (
  | patchV1SitesIdAudioClassesResponse400
  | patchV1SitesIdAudioClassesResponse404
  | patchV1SitesIdAudioClassesResponse409
) & {
  headers: Headers;
};

export type patchV1SitesIdAudioClassesResponse =
  | patchV1SitesIdAudioClassesResponseSuccess
  | patchV1SitesIdAudioClassesResponseError;

export const getPatchV1SitesIdAudioClassesUrl = (id: string) => {
  return `/v1/sites/${id}/audio-classes`;
};

export const patchV1SitesIdAudioClasses = async (
  id: string,
  updateAudioClassesRequest: UpdateAudioClassesRequest,
  options?: RequestInit,
): Promise<patchV1SitesIdAudioClassesResponse> => {
  return cguardFetcher<patchV1SitesIdAudioClassesResponse>(getPatchV1SitesIdAudioClassesUrl(id), {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateAudioClassesRequest),
  });
};

export const getPatchV1SitesIdAudioClassesMutationOptions = <
  TError = HttpValidationProblemDetails | ProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchV1SitesIdAudioClasses>>,
    TError,
    { id: string; data: UpdateAudioClassesRequest },
    TContext
  >;
  request?: SecondParameter<typeof cguardFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchV1SitesIdAudioClasses>>,
  TError,
  { id: string; data: UpdateAudioClassesRequest },
  TContext
> => {
  const mutationKey = ['patchV1SitesIdAudioClasses'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchV1SitesIdAudioClasses>>,
    { id: string; data: UpdateAudioClassesRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return patchV1SitesIdAudioClasses(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchV1SitesIdAudioClassesMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchV1SitesIdAudioClasses>>
>;
export type PatchV1SitesIdAudioClassesMutationBody = UpdateAudioClassesRequest;
export type PatchV1SitesIdAudioClassesMutationError = HttpValidationProblemDetails | ProblemDetails;

export const usePatchV1SitesIdAudioClasses = <
  TError = HttpValidationProblemDetails | ProblemDetails,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchV1SitesIdAudioClasses>>,
      TError,
      { id: string; data: UpdateAudioClassesRequest },
      TContext
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof patchV1SitesIdAudioClasses>>,
  TError,
  { id: string; data: UpdateAudioClassesRequest },
  TContext
> => {
  return useMutation(getPatchV1SitesIdAudioClassesMutationOptions(options), queryClient);
};
export type postV1SitesIdLiveResponse204 = {
  data: void;
  status: 204;
};

export type postV1SitesIdLiveResponse400 = {
  data: HttpValidationProblemDetails;
  status: 400;
};

export type postV1SitesIdLiveResponse404 = {
  data: ProblemDetails;
  status: 404;
};

export type postV1SitesIdLiveResponse409 = {
  data: ProblemDetails;
  status: 409;
};

export type postV1SitesIdLiveResponseSuccess = postV1SitesIdLiveResponse204 & {
  headers: Headers;
};
export type postV1SitesIdLiveResponseError = (
  | postV1SitesIdLiveResponse400
  | postV1SitesIdLiveResponse404
  | postV1SitesIdLiveResponse409
) & {
  headers: Headers;
};

export type postV1SitesIdLiveResponse =
  | postV1SitesIdLiveResponseSuccess
  | postV1SitesIdLiveResponseError;

export const getPostV1SitesIdLiveUrl = (id: string) => {
  return `/v1/sites/${id}/live`;
};

export const postV1SitesIdLive = async (
  id: string,
  markSiteLiveRequest: MarkSiteLiveRequest,
  options?: RequestInit,
): Promise<postV1SitesIdLiveResponse> => {
  return cguardFetcher<postV1SitesIdLiveResponse>(getPostV1SitesIdLiveUrl(id), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(markSiteLiveRequest),
  });
};

export const getPostV1SitesIdLiveMutationOptions = <
  TError = HttpValidationProblemDetails | ProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV1SitesIdLive>>,
    TError,
    { id: string; data: MarkSiteLiveRequest },
    TContext
  >;
  request?: SecondParameter<typeof cguardFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV1SitesIdLive>>,
  TError,
  { id: string; data: MarkSiteLiveRequest },
  TContext
> => {
  const mutationKey = ['postV1SitesIdLive'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV1SitesIdLive>>,
    { id: string; data: MarkSiteLiveRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return postV1SitesIdLive(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV1SitesIdLiveMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV1SitesIdLive>>
>;
export type PostV1SitesIdLiveMutationBody = MarkSiteLiveRequest;
export type PostV1SitesIdLiveMutationError = HttpValidationProblemDetails | ProblemDetails;

export const usePostV1SitesIdLive = <
  TError = HttpValidationProblemDetails | ProblemDetails,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV1SitesIdLive>>,
      TError,
      { id: string; data: MarkSiteLiveRequest },
      TContext
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postV1SitesIdLive>>,
  TError,
  { id: string; data: MarkSiteLiveRequest },
  TContext
> => {
  return useMutation(getPostV1SitesIdLiveMutationOptions(options), queryClient);
};
export type postV1SitesIdLiveOverrideResponse204 = {
  data: void;
  status: 204;
};

export type postV1SitesIdLiveOverrideResponse400 = {
  data: HttpValidationProblemDetails;
  status: 400;
};

export type postV1SitesIdLiveOverrideResponse403 = {
  data: ProblemDetails;
  status: 403;
};

export type postV1SitesIdLiveOverrideResponse404 = {
  data: ProblemDetails;
  status: 404;
};

export type postV1SitesIdLiveOverrideResponse409 = {
  data: ProblemDetails;
  status: 409;
};

export type postV1SitesIdLiveOverrideResponse500 = {
  data: ProblemDetails;
  status: 500;
};

export type postV1SitesIdLiveOverrideResponseSuccess = postV1SitesIdLiveOverrideResponse204 & {
  headers: Headers;
};
export type postV1SitesIdLiveOverrideResponseError = (
  | postV1SitesIdLiveOverrideResponse400
  | postV1SitesIdLiveOverrideResponse403
  | postV1SitesIdLiveOverrideResponse404
  | postV1SitesIdLiveOverrideResponse409
  | postV1SitesIdLiveOverrideResponse500
) & {
  headers: Headers;
};

export type postV1SitesIdLiveOverrideResponse =
  | postV1SitesIdLiveOverrideResponseSuccess
  | postV1SitesIdLiveOverrideResponseError;

export const getPostV1SitesIdLiveOverrideUrl = (id: string) => {
  return `/v1/sites/${id}/live/override`;
};

export const postV1SitesIdLiveOverride = async (
  id: string,
  overrideSiteGoLiveRequest: OverrideSiteGoLiveRequest,
  options?: RequestInit,
): Promise<postV1SitesIdLiveOverrideResponse> => {
  return cguardFetcher<postV1SitesIdLiveOverrideResponse>(getPostV1SitesIdLiveOverrideUrl(id), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(overrideSiteGoLiveRequest),
  });
};

export const getPostV1SitesIdLiveOverrideMutationOptions = <
  TError = HttpValidationProblemDetails | ProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV1SitesIdLiveOverride>>,
    TError,
    { id: string; data: OverrideSiteGoLiveRequest },
    TContext
  >;
  request?: SecondParameter<typeof cguardFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV1SitesIdLiveOverride>>,
  TError,
  { id: string; data: OverrideSiteGoLiveRequest },
  TContext
> => {
  const mutationKey = ['postV1SitesIdLiveOverride'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV1SitesIdLiveOverride>>,
    { id: string; data: OverrideSiteGoLiveRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return postV1SitesIdLiveOverride(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV1SitesIdLiveOverrideMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV1SitesIdLiveOverride>>
>;
export type PostV1SitesIdLiveOverrideMutationBody = OverrideSiteGoLiveRequest;
export type PostV1SitesIdLiveOverrideMutationError = HttpValidationProblemDetails | ProblemDetails;

export const usePostV1SitesIdLiveOverride = <
  TError = HttpValidationProblemDetails | ProblemDetails,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV1SitesIdLiveOverride>>,
      TError,
      { id: string; data: OverrideSiteGoLiveRequest },
      TContext
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postV1SitesIdLiveOverride>>,
  TError,
  { id: string; data: OverrideSiteGoLiveRequest },
  TContext
> => {
  return useMutation(getPostV1SitesIdLiveOverrideMutationOptions(options), queryClient);
};
export type postV1SitesIdComplianceCertificatesCertificateIdSuspendResponse200 = {
  data: SiteComplianceCertificateResponse;
  status: 200;
};

export type postV1SitesIdComplianceCertificatesCertificateIdSuspendResponse400 = {
  data: HttpValidationProblemDetails;
  status: 400;
};

export type postV1SitesIdComplianceCertificatesCertificateIdSuspendResponse404 = {
  data: ProblemDetails;
  status: 404;
};

export type postV1SitesIdComplianceCertificatesCertificateIdSuspendResponse409 = {
  data: ProblemDetails;
  status: 409;
};

export type postV1SitesIdComplianceCertificatesCertificateIdSuspendResponseSuccess =
  postV1SitesIdComplianceCertificatesCertificateIdSuspendResponse200 & {
    headers: Headers;
  };
export type postV1SitesIdComplianceCertificatesCertificateIdSuspendResponseError = (
  | postV1SitesIdComplianceCertificatesCertificateIdSuspendResponse400
  | postV1SitesIdComplianceCertificatesCertificateIdSuspendResponse404
  | postV1SitesIdComplianceCertificatesCertificateIdSuspendResponse409
) & {
  headers: Headers;
};

export type postV1SitesIdComplianceCertificatesCertificateIdSuspendResponse =
  | postV1SitesIdComplianceCertificatesCertificateIdSuspendResponseSuccess
  | postV1SitesIdComplianceCertificatesCertificateIdSuspendResponseError;

export const getPostV1SitesIdComplianceCertificatesCertificateIdSuspendUrl = (
  id: string,
  certificateId: string,
) => {
  return `/v1/sites/${id}/compliance-certificates/${certificateId}/suspend`;
};

export const postV1SitesIdComplianceCertificatesCertificateIdSuspend = async (
  id: string,
  certificateId: string,
  transitionSiteComplianceCertificateRequest: TransitionSiteComplianceCertificateRequest,
  options?: RequestInit,
): Promise<postV1SitesIdComplianceCertificatesCertificateIdSuspendResponse> => {
  return cguardFetcher<postV1SitesIdComplianceCertificatesCertificateIdSuspendResponse>(
    getPostV1SitesIdComplianceCertificatesCertificateIdSuspendUrl(id, certificateId),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(transitionSiteComplianceCertificateRequest),
    },
  );
};

export const getPostV1SitesIdComplianceCertificatesCertificateIdSuspendMutationOptions = <
  TError = HttpValidationProblemDetails | ProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV1SitesIdComplianceCertificatesCertificateIdSuspend>>,
    TError,
    { id: string; certificateId: string; data: TransitionSiteComplianceCertificateRequest },
    TContext
  >;
  request?: SecondParameter<typeof cguardFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV1SitesIdComplianceCertificatesCertificateIdSuspend>>,
  TError,
  { id: string; certificateId: string; data: TransitionSiteComplianceCertificateRequest },
  TContext
> => {
  const mutationKey = ['postV1SitesIdComplianceCertificatesCertificateIdSuspend'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV1SitesIdComplianceCertificatesCertificateIdSuspend>>,
    { id: string; certificateId: string; data: TransitionSiteComplianceCertificateRequest }
  > = (props) => {
    const { id, certificateId, data } = props ?? {};

    return postV1SitesIdComplianceCertificatesCertificateIdSuspend(
      id,
      certificateId,
      data,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV1SitesIdComplianceCertificatesCertificateIdSuspendMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV1SitesIdComplianceCertificatesCertificateIdSuspend>>
>;
export type PostV1SitesIdComplianceCertificatesCertificateIdSuspendMutationBody =
  TransitionSiteComplianceCertificateRequest;
export type PostV1SitesIdComplianceCertificatesCertificateIdSuspendMutationError =
  | HttpValidationProblemDetails
  | ProblemDetails;

export const usePostV1SitesIdComplianceCertificatesCertificateIdSuspend = <
  TError = HttpValidationProblemDetails | ProblemDetails,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV1SitesIdComplianceCertificatesCertificateIdSuspend>>,
      TError,
      { id: string; certificateId: string; data: TransitionSiteComplianceCertificateRequest },
      TContext
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postV1SitesIdComplianceCertificatesCertificateIdSuspend>>,
  TError,
  { id: string; certificateId: string; data: TransitionSiteComplianceCertificateRequest },
  TContext
> => {
  return useMutation(
    getPostV1SitesIdComplianceCertificatesCertificateIdSuspendMutationOptions(options),
    queryClient,
  );
};
export type postV1SitesIdComplianceCertificatesCertificateIdRequireReverificationResponse200 = {
  data: SiteComplianceCertificateResponse;
  status: 200;
};

export type postV1SitesIdComplianceCertificatesCertificateIdRequireReverificationResponse400 = {
  data: HttpValidationProblemDetails;
  status: 400;
};

export type postV1SitesIdComplianceCertificatesCertificateIdRequireReverificationResponse404 = {
  data: ProblemDetails;
  status: 404;
};

export type postV1SitesIdComplianceCertificatesCertificateIdRequireReverificationResponse409 = {
  data: ProblemDetails;
  status: 409;
};

export type postV1SitesIdComplianceCertificatesCertificateIdRequireReverificationResponseSuccess =
  postV1SitesIdComplianceCertificatesCertificateIdRequireReverificationResponse200 & {
    headers: Headers;
  };
export type postV1SitesIdComplianceCertificatesCertificateIdRequireReverificationResponseError = (
  | postV1SitesIdComplianceCertificatesCertificateIdRequireReverificationResponse400
  | postV1SitesIdComplianceCertificatesCertificateIdRequireReverificationResponse404
  | postV1SitesIdComplianceCertificatesCertificateIdRequireReverificationResponse409
) & {
  headers: Headers;
};

export type postV1SitesIdComplianceCertificatesCertificateIdRequireReverificationResponse =
  | postV1SitesIdComplianceCertificatesCertificateIdRequireReverificationResponseSuccess
  | postV1SitesIdComplianceCertificatesCertificateIdRequireReverificationResponseError;

export const getPostV1SitesIdComplianceCertificatesCertificateIdRequireReverificationUrl = (
  id: string,
  certificateId: string,
) => {
  return `/v1/sites/${id}/compliance-certificates/${certificateId}/require-reverification`;
};

export const postV1SitesIdComplianceCertificatesCertificateIdRequireReverification = async (
  id: string,
  certificateId: string,
  transitionSiteComplianceCertificateRequest: TransitionSiteComplianceCertificateRequest,
  options?: RequestInit,
): Promise<postV1SitesIdComplianceCertificatesCertificateIdRequireReverificationResponse> => {
  return cguardFetcher<postV1SitesIdComplianceCertificatesCertificateIdRequireReverificationResponse>(
    getPostV1SitesIdComplianceCertificatesCertificateIdRequireReverificationUrl(id, certificateId),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(transitionSiteComplianceCertificateRequest),
    },
  );
};

export const getPostV1SitesIdComplianceCertificatesCertificateIdRequireReverificationMutationOptions =
  <TError = HttpValidationProblemDetails | ProblemDetails, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postV1SitesIdComplianceCertificatesCertificateIdRequireReverification>
      >,
      TError,
      { id: string; certificateId: string; data: TransitionSiteComplianceCertificateRequest },
      TContext
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof postV1SitesIdComplianceCertificatesCertificateIdRequireReverification>
    >,
    TError,
    { id: string; certificateId: string; data: TransitionSiteComplianceCertificateRequest },
    TContext
  > => {
    const mutationKey = ['postV1SitesIdComplianceCertificatesCertificateIdRequireReverification'];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postV1SitesIdComplianceCertificatesCertificateIdRequireReverification>
      >,
      { id: string; certificateId: string; data: TransitionSiteComplianceCertificateRequest }
    > = (props) => {
      const { id, certificateId, data } = props ?? {};

      return postV1SitesIdComplianceCertificatesCertificateIdRequireReverification(
        id,
        certificateId,
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostV1SitesIdComplianceCertificatesCertificateIdRequireReverificationMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof postV1SitesIdComplianceCertificatesCertificateIdRequireReverification>
    >
  >;
export type PostV1SitesIdComplianceCertificatesCertificateIdRequireReverificationMutationBody =
  TransitionSiteComplianceCertificateRequest;
export type PostV1SitesIdComplianceCertificatesCertificateIdRequireReverificationMutationError =
  | HttpValidationProblemDetails
  | ProblemDetails;

export const usePostV1SitesIdComplianceCertificatesCertificateIdRequireReverification = <
  TError = HttpValidationProblemDetails | ProblemDetails,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postV1SitesIdComplianceCertificatesCertificateIdRequireReverification>
      >,
      TError,
      { id: string; certificateId: string; data: TransitionSiteComplianceCertificateRequest },
      TContext
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postV1SitesIdComplianceCertificatesCertificateIdRequireReverification>>,
  TError,
  { id: string; certificateId: string; data: TransitionSiteComplianceCertificateRequest },
  TContext
> => {
  return useMutation(
    getPostV1SitesIdComplianceCertificatesCertificateIdRequireReverificationMutationOptions(
      options,
    ),
    queryClient,
  );
};
export type postV1SitesIdComplianceCertificatesCertificateIdExpireResponse200 = {
  data: SiteComplianceCertificateResponse;
  status: 200;
};

export type postV1SitesIdComplianceCertificatesCertificateIdExpireResponse400 = {
  data: HttpValidationProblemDetails;
  status: 400;
};

export type postV1SitesIdComplianceCertificatesCertificateIdExpireResponse404 = {
  data: ProblemDetails;
  status: 404;
};

export type postV1SitesIdComplianceCertificatesCertificateIdExpireResponse409 = {
  data: ProblemDetails;
  status: 409;
};

export type postV1SitesIdComplianceCertificatesCertificateIdExpireResponseSuccess =
  postV1SitesIdComplianceCertificatesCertificateIdExpireResponse200 & {
    headers: Headers;
  };
export type postV1SitesIdComplianceCertificatesCertificateIdExpireResponseError = (
  | postV1SitesIdComplianceCertificatesCertificateIdExpireResponse400
  | postV1SitesIdComplianceCertificatesCertificateIdExpireResponse404
  | postV1SitesIdComplianceCertificatesCertificateIdExpireResponse409
) & {
  headers: Headers;
};

export type postV1SitesIdComplianceCertificatesCertificateIdExpireResponse =
  | postV1SitesIdComplianceCertificatesCertificateIdExpireResponseSuccess
  | postV1SitesIdComplianceCertificatesCertificateIdExpireResponseError;

export const getPostV1SitesIdComplianceCertificatesCertificateIdExpireUrl = (
  id: string,
  certificateId: string,
) => {
  return `/v1/sites/${id}/compliance-certificates/${certificateId}/expire`;
};

export const postV1SitesIdComplianceCertificatesCertificateIdExpire = async (
  id: string,
  certificateId: string,
  transitionSiteComplianceCertificateRequest: TransitionSiteComplianceCertificateRequest,
  options?: RequestInit,
): Promise<postV1SitesIdComplianceCertificatesCertificateIdExpireResponse> => {
  return cguardFetcher<postV1SitesIdComplianceCertificatesCertificateIdExpireResponse>(
    getPostV1SitesIdComplianceCertificatesCertificateIdExpireUrl(id, certificateId),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(transitionSiteComplianceCertificateRequest),
    },
  );
};

export const getPostV1SitesIdComplianceCertificatesCertificateIdExpireMutationOptions = <
  TError = HttpValidationProblemDetails | ProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV1SitesIdComplianceCertificatesCertificateIdExpire>>,
    TError,
    { id: string; certificateId: string; data: TransitionSiteComplianceCertificateRequest },
    TContext
  >;
  request?: SecondParameter<typeof cguardFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV1SitesIdComplianceCertificatesCertificateIdExpire>>,
  TError,
  { id: string; certificateId: string; data: TransitionSiteComplianceCertificateRequest },
  TContext
> => {
  const mutationKey = ['postV1SitesIdComplianceCertificatesCertificateIdExpire'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV1SitesIdComplianceCertificatesCertificateIdExpire>>,
    { id: string; certificateId: string; data: TransitionSiteComplianceCertificateRequest }
  > = (props) => {
    const { id, certificateId, data } = props ?? {};

    return postV1SitesIdComplianceCertificatesCertificateIdExpire(
      id,
      certificateId,
      data,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV1SitesIdComplianceCertificatesCertificateIdExpireMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV1SitesIdComplianceCertificatesCertificateIdExpire>>
>;
export type PostV1SitesIdComplianceCertificatesCertificateIdExpireMutationBody =
  TransitionSiteComplianceCertificateRequest;
export type PostV1SitesIdComplianceCertificatesCertificateIdExpireMutationError =
  | HttpValidationProblemDetails
  | ProblemDetails;

export const usePostV1SitesIdComplianceCertificatesCertificateIdExpire = <
  TError = HttpValidationProblemDetails | ProblemDetails,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV1SitesIdComplianceCertificatesCertificateIdExpire>>,
      TError,
      { id: string; certificateId: string; data: TransitionSiteComplianceCertificateRequest },
      TContext
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postV1SitesIdComplianceCertificatesCertificateIdExpire>>,
  TError,
  { id: string; certificateId: string; data: TransitionSiteComplianceCertificateRequest },
  TContext
> => {
  return useMutation(
    getPostV1SitesIdComplianceCertificatesCertificateIdExpireMutationOptions(options),
    queryClient,
  );
};
export type postV1SitesIdDecommissionResponse204 = {
  data: void;
  status: 204;
};

export type postV1SitesIdDecommissionResponse400 = {
  data: HttpValidationProblemDetails;
  status: 400;
};

export type postV1SitesIdDecommissionResponse404 = {
  data: ProblemDetails;
  status: 404;
};

export type postV1SitesIdDecommissionResponse409 = {
  data: ProblemDetails;
  status: 409;
};

export type postV1SitesIdDecommissionResponseSuccess = postV1SitesIdDecommissionResponse204 & {
  headers: Headers;
};
export type postV1SitesIdDecommissionResponseError = (
  | postV1SitesIdDecommissionResponse400
  | postV1SitesIdDecommissionResponse404
  | postV1SitesIdDecommissionResponse409
) & {
  headers: Headers;
};

export type postV1SitesIdDecommissionResponse =
  | postV1SitesIdDecommissionResponseSuccess
  | postV1SitesIdDecommissionResponseError;

export const getPostV1SitesIdDecommissionUrl = (id: string) => {
  return `/v1/sites/${id}/decommission`;
};

export const postV1SitesIdDecommission = async (
  id: string,
  options?: RequestInit,
): Promise<postV1SitesIdDecommissionResponse> => {
  return cguardFetcher<postV1SitesIdDecommissionResponse>(getPostV1SitesIdDecommissionUrl(id), {
    ...options,
    method: 'POST',
  });
};

export const getPostV1SitesIdDecommissionMutationOptions = <
  TError = HttpValidationProblemDetails | ProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV1SitesIdDecommission>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof cguardFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV1SitesIdDecommission>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['postV1SitesIdDecommission'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV1SitesIdDecommission>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return postV1SitesIdDecommission(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV1SitesIdDecommissionMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV1SitesIdDecommission>>
>;

export type PostV1SitesIdDecommissionMutationError = HttpValidationProblemDetails | ProblemDetails;

export const usePostV1SitesIdDecommission = <
  TError = HttpValidationProblemDetails | ProblemDetails,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV1SitesIdDecommission>>,
      TError,
      { id: string },
      TContext
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postV1SitesIdDecommission>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getPostV1SitesIdDecommissionMutationOptions(options), queryClient);
};
export type postV1SitesIdRestoreResponse204 = {
  data: void;
  status: 204;
};

export type postV1SitesIdRestoreResponse400 = {
  data: HttpValidationProblemDetails;
  status: 400;
};

export type postV1SitesIdRestoreResponse404 = {
  data: ProblemDetails;
  status: 404;
};

export type postV1SitesIdRestoreResponse409 = {
  data: ProblemDetails;
  status: 409;
};

export type postV1SitesIdRestoreResponseSuccess = postV1SitesIdRestoreResponse204 & {
  headers: Headers;
};
export type postV1SitesIdRestoreResponseError = (
  | postV1SitesIdRestoreResponse400
  | postV1SitesIdRestoreResponse404
  | postV1SitesIdRestoreResponse409
) & {
  headers: Headers;
};

export type postV1SitesIdRestoreResponse =
  | postV1SitesIdRestoreResponseSuccess
  | postV1SitesIdRestoreResponseError;

export const getPostV1SitesIdRestoreUrl = (id: string) => {
  return `/v1/sites/${id}/restore`;
};

export const postV1SitesIdRestore = async (
  id: string,
  restoreSiteRequest: RestoreSiteRequest,
  options?: RequestInit,
): Promise<postV1SitesIdRestoreResponse> => {
  return cguardFetcher<postV1SitesIdRestoreResponse>(getPostV1SitesIdRestoreUrl(id), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(restoreSiteRequest),
  });
};

export const getPostV1SitesIdRestoreMutationOptions = <
  TError = HttpValidationProblemDetails | ProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV1SitesIdRestore>>,
    TError,
    { id: string; data: RestoreSiteRequest },
    TContext
  >;
  request?: SecondParameter<typeof cguardFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV1SitesIdRestore>>,
  TError,
  { id: string; data: RestoreSiteRequest },
  TContext
> => {
  const mutationKey = ['postV1SitesIdRestore'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV1SitesIdRestore>>,
    { id: string; data: RestoreSiteRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return postV1SitesIdRestore(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV1SitesIdRestoreMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV1SitesIdRestore>>
>;
export type PostV1SitesIdRestoreMutationBody = RestoreSiteRequest;
export type PostV1SitesIdRestoreMutationError = HttpValidationProblemDetails | ProblemDetails;

export const usePostV1SitesIdRestore = <
  TError = HttpValidationProblemDetails | ProblemDetails,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV1SitesIdRestore>>,
      TError,
      { id: string; data: RestoreSiteRequest },
      TContext
    >;
    request?: SecondParameter<typeof cguardFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postV1SitesIdRestore>>,
  TError,
  { id: string; data: RestoreSiteRequest },
  TContext
> => {
  return useMutation(getPostV1SitesIdRestoreMutationOptions(options), queryClient);
};
